
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class InfoField extends Vue {
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: [String, Number, Boolean, Array, Object], default: null })
  readonly value: any;
  @Prop({ type: Boolean, default: false }) readonly optional!: boolean;
  @Prop({ type: String, default: "N/A" }) readonly defaultText!: string;
}
